import {ReceiverGroup} from "./ReceiverGroup"
import {TemplateWithoutBody} from "./Template"
import {Domain} from "./Domain"

export type Campaign = {
    campaignId?: string,
    name: string,
    startDate: Date,
    endDate: Date,
    dayStartTime: Date,
    dayEndTime: Date,
    sendDays: string,
    baselineEnabled: boolean,
    baselineEndDate: Date,
    timezone: string,
    status: string,
    baselineTemplates?: TemplateWithoutBody[],
    followUpTemplates?: TemplateWithoutBody[],
    receiverGroups: ReceiverGroup[],
    domains: Domain[],
    demo?: boolean,
}
export type CampaignStatus = {
    status: Status,
}
export type CampaignReceiverGroups = [
    {
        receiverGroupId: string
    }
]
export type CampaignDomains = [
    {
        domainId: string,
        type: string,
        domain: string,
    }
]
export type CampaignTemplate = {
        templateId: string
    }
export type CampaignTemplates = CampaignTemplate[];

export enum Status {
    IN_CONFIGURATION = "In configuration",
    READY = "Ready",
    RUNNING = "Running",
    PAUSED = "Paused",
    FINISHED = "Finished",
    CANCELLED = "Cancelled"
}